"use client";

import { Dots } from "@pamperedchef/design-system";
import type { MouseEvent } from "react";

import * as styles from "./ListingPageLink.module.scss";

export interface ListingPageLinkProps {
	href: string;
	rel: "next" | "prev";
	label: string;
	isLoading?: boolean;
	/** Loads the page in place; without it the link loads its url. */
	onNavigate?: () => void;
}

export function ListingPageLink({
	href,
	rel,
	label,
	isLoading = false,
	onNavigate
}: ListingPageLinkProps): JSX.Element {
	function handleClick(event: MouseEvent<HTMLAnchorElement>): void {
		if (!onNavigate || event.metaKey || event.ctrlKey || event.shiftKey) {
			return;
		}
		event.preventDefault();
		if (!isLoading) onNavigate();
	}

	return (
		<a
			href={href}
			rel={rel}
			className={styles["page-link"]}
			aria-disabled={isLoading || undefined}
			aria-label={isLoading ? label : undefined}
			onClick={handleClick}
		>
			{isLoading ? <Dots aria-hidden /> : label}
		</a>
	);
}
